import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import sixLoveMark from '../../assets/6love-mark.svg';
import './landing.css';

/* The marketing page is the public root. Login lives behind its own route. */
export const LOGIN_PATH = '/login';

/* ---------- Wordmark ---------- */
export const Wordmark: React.FC<{ size?: number; onDark?: boolean }> = ({ size = 20, onDark = false }) => (
  <span className={`lp-wordmark${onDark ? ' lp-wordmark--ondark' : ''}`} style={{ gap: size * 0.42 }}>
    <img src={sixLoveMark} alt="" style={{ width: size * 1.5, height: size * 1.5 }} />
    <span className="lp-wordmark-text" style={{ fontSize: size }}>
      <span className="six">6</span>-love
    </span>
  </span>
);

/* ---------- Button ---------- */
type LpVariant = 'accent' | 'outline' | 'ghost';
type LpSize = 'sm' | 'md' | 'lg';
export const LpButton: React.FC<{
  variant?: LpVariant; size?: LpSize; onClick?: () => void;
  iconLeft?: React.ReactNode; iconRight?: React.ReactNode; children: React.ReactNode;
}> = ({ variant = 'accent', size = 'md', onClick, iconLeft, iconRight, children }) => (
  <button type="button" className={`lp-btn lp-btn--${variant} lp-btn--${size}`} onClick={onClick}>
    {iconLeft}{children}{iconRight}
  </button>
);

/* ---------- Nav ----------
   Shared between the landing page and the login screen. When rendered on the
   landing page (atHome), the logo and section links use in-page anchors; off
   the landing page they route back to "/" with the matching hash. */
export const LandingNav: React.FC<{ atHome?: boolean }> = ({ atHome = false }) => {
  const navigate = useNavigate();
  const goLogin = () => navigate(LOGIN_PATH);
  const homeHref = atHome ? '#top' : '/';
  const sectionHref = (id: string) => (atHome ? `#${id}` : `/#${id}`);

  return (
    <header className="lp-nav">
      <div className="lp-nav-inner">
        <a href={homeHref} aria-label="6-love home" style={{ display: 'inline-flex' }}><Wordmark size={20} /></a>
        <nav className="lp-nav-links">
          <a href={sectionHref('features')}>Features</a>
          <Link to="/pricing">Pricing</Link>
          <a href={sectionHref('cocaptain')}>AI Co-Captain</a>
          <a href={sectionHref('how')}>How it works</a>
        </nav>
        <div className="lp-nav-actions">
          <Link to={LOGIN_PATH} className="lp-nav-login">Log in</Link>
          <LpButton variant="accent" size="md" onClick={goLogin}>Get started</LpButton>
        </div>
      </div>
    </header>
  );
};
